module.exports = __webpack_public_path__ + "static/media/seat_arrangement_title_m.abc7b64d.png";